import { MonoTypeOperatorFunction, Observable, timer } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

/**
 * This operator caches the value from source observable for as defined by `timeToLive` config.
 * The given observable is initialized only when it is requested the first time.
 */
export function cache<T>({ timeToLive = Infinity }: { timeToLive?: number } = {}): MonoTypeOperatorFunction<T> {
  return (source: Observable<T>): Observable<T> =>
    timer(0, timeToLive).pipe(
      switchMap(() => source),
      shareReplay(1)
    );
}
